module.exports = __webpack_public_path__ + "img/how8.192f6761.png";